import React, { Suspense } from 'react';
import { RouteComponentProps } from '@reach/router';
import EmployeeContactList from '../common/EmployeeContactList';

interface IDeveloperDashboardProps extends RouteComponentProps {}

// TODO: Reported errors
// TODO: Code coverage
// TODO: Top slowest functions/pages
// TODO: Pages that utilize the most reads

const DeveloperDashboard: React.FC<IDeveloperDashboardProps> = () => {
    return <div className="row">
        <div className="col-md-8 mx-auto">
            <h6 className="divider">TBD</h6>
            Developer Dashboard
        </div>

        <div className="col-md-4 mx-auto">
            <Suspense fallback={<div>Loading...</div>}>
                <EmployeeContactList />
            </Suspense>
        </div>
    </div>;
}

export default DeveloperDashboard;
